// Ticket status values → labels shown to the team.
// 'open' is stored as-is for compatibility but means "in progress" (we replied, work remains).
export const STATUS_LABELS = {
  new: 'New',
  open: 'In progress',
  pending: 'Pending',
  resolved: 'Resolved',
  closed: 'Closed',
  archived: 'Archived',
};

export function statusLabel(status) {
  return STATUS_LABELS[status] || String(status || '-').replace(/^\w/, (c) => c.toUpperCase());
}

export const CHANNEL_LABELS = { instagram: 'Instagram', messenger: 'Messenger' };

// Meta's reply window for Instagram/Messenger: normal replies for 24h after the customer's last
// message, then up to 7 days with the "human agent" tag.
export function replyWindowText(expiresMs, nowMs = Date.now()) {
  if (!expiresMs) return null;
  const left = expiresMs - nowMs;
  if (left > 0) {
    const h = Math.floor(left / 3600e3);
    const m = Math.floor((left % 3600e3) / 60000);
    return { urgent: left < 3 * 3600e3, text: `⏱ ${h ? `${h}h ` : ''}${m}m left to reply` };
  }
  const humanLeft = expiresMs + 6 * 24 * 3600e3 - nowMs;
  if (humanLeft > 0) return { urgent: true, text: `24h window passed — ${Math.ceil(humanLeft / 86400e3)}d left (human agent reply)` };
  return { urgent: true, text: 'Reply window closed (7 days)' };
}
